import React from 'react';
import { withRouter } from 'react-router-dom';

import './user-photo.scss';
import { FluentAvatar } from '../FluentUI/Fluent-Avatar';

class UserPhoto extends React.Component {

    constructor(Props) {
        super(Props);

        let name = this.props.name;
        let userCreate = this.props.location.pathname.includes("users");
        let departmentCreate = this.props.location.pathname.includes("department");

        if (this.props.group) {
            name = this.props.name.substr(this.props.name.indexOf(" ") + 1);
        }
        else if (this.props.groupMember) {
            name = this.props.name.substr(0, this.props.name.indexOf('-') - 1)
        }

        if(name == "TRIYO")
            name ="T R"

        this.state = {
            photo: this.props.photo || "",
            photoBase64: this.props.photoBase64 || "",
            name: name || '',
            userCreate: userCreate,
            departmentCreate: departmentCreate
        }
        
    }

    componentDidUpdate = (prevProps) => {
        if (this.state.departmentCreate && this.props.photo !== prevProps.photo){
            this.setState({
                ...this.props,
            })
        } 
        else if(this.props.name !== prevProps.name) {
            let name = this.props.name;
    
            if (this.props.group) {
                name = this.props.name.substr(this.props.name.indexOf(" ") + 1);
            }
            else if (this.props.groupMember) {
                name = this.props.name.substr(0, this.props.name.indexOf('-') - 1)
            }
    
            this.setState({
                ...prevProps,
                name: name
            })
        }       
    }

    generateUserPhoto = () => {
        if (this.state.userCreate) return <div className="user-create-photo-icon" />;
        if (this.state.departmentCreate) return <div className="department-create-photo-icon" />
        return (
            <>  
                {/* Keeping this code in case of future bugs in user photot */}
                {/* <div className= {(this.props.owner) || (this.props.task == true && !this.props.docTask  && !this.props.tOwner) || (this.props.docTask == true) || (this.props.tOwner) || (this.props.ownerAdjusted) ? 
                "user-photo-icon owner-member-blue" : "user-photo-icon"}>
                    <p className="user-photo-name">
                        {
                            this.state.name.split(" ").reduce((initials, word) => initials + word.charAt(0).toUpperCase(), "").substring(0, 2)
                        }
                    </p>
                </div> */}
                <FluentAvatar
                    size={this.props.size ?? 28}
                    color={this.props.color}
                    name={this.state.name}
                    className="user-photo-icon"></FluentAvatar>
                
            </>
        )
    }

    render = () => {
        return (
            <div className={this.props.comments ? "user-photo-comment" : "user-photo " + this.props.className}>
                {
                    this.state.photoBase64 !== ""
                        ?
                        <div className="user-photo-icon" style={{ backgroundImage: `url(${this.state.photoBase64})` }}>
                        </div>
                        :
                        this.state.photo !== ""
                            ?
                            <div className="user-photo-icon" style={{ backgroundImage: `url(${this.state.photo})` }}>
                                {
                                    this.props.owner ?
                                        <div className="owner-member-dot"></div>
                                        : <></>
                                }
                            </div>
                            :
                            this.generateUserPhoto()
                }
            </div>
        )
    }
}

export default withRouter(UserPhoto);